import { useState } from 'react';
import { API_URL } from '../hooks/useAuth';

const SHOP_RE = /^[a-z0-9][a-z0-9-]*\.myshopify\.com$/;

export const normalizeShop = (v) => (v || '').trim().toLowerCase().replace(/^https?:\/\//, '').replace(/\/.*$/, '');

// Remember to re-open the plan modal after the merchant returns from Shopify OAuth
export const startShopifyConnect = (shop) => {
  sessionStorage.setItem('dsk_resume_billing', '1');
  window.location.href = `${API_URL}/api/auth/shopify?shop=${encodeURIComponent(normalizeShop(shop))}`;
};

// Inline "Connect your Shopify store" form (pre-filled with a known store when available)
export const ConnectStoreForm = ({ defaultShop, message, compact = false }) => {
  const [shop, setShop] = useState(defaultShop || '');
  const valid = SHOP_RE.test(normalizeShop(shop));
  return (
    <div data-testid="connect-store-form" style={{display:'flex',flexDirection:'column',gap:'8px',padding: compact ? '0' : '12px',background: compact ? 'transparent' : 'rgba(200,170,160,0.18)',border: compact ? 'none' : '1px solid #c4a69a',borderRadius:'6px'}}>
      {message && <p data-testid="connect-store-message" style={{fontSize:'12px',color:'var(--accent-red)',margin:0}}>{message}</p>}
      <p style={{fontSize:'12px',color:'var(--text-muted)',margin:0}}>Subscriptions are billed through Shopify. Enter your store domain to connect it.</p>
      <div style={{display:'flex',gap:'8px',flexWrap:'wrap'}}>
        <input
          className="beige-input"
          value={shop}
          onChange={(e) => setShop(e.target.value)}
          placeholder="your-store.myshopify.com"
          data-testid="connect-store-input"
          style={{flex:1,minWidth:'220px'}}
        />
        <button
          className="metal-btn"
          disabled={!valid}
          onClick={() => startShopifyConnect(shop)}
          data-testid="connect-store-btn"
        >
          Connect your Shopify store
        </button>
      </div>
      {shop && !valid && <span style={{fontSize:'11px',color:'var(--text-muted)'}}>Use the format <code>your-store.myshopify.com</code></span>}
    </div>
  );
};
